import { ConstantModel } from "@core/models/outros/constant.model";

export const FINANCIAL_RELEASE_GROUP_TYPE: ConstantModel[] = [
  {
    id: 1,
    descricao: 'DESPESA',
    enum: 'DB'
  },
  {
    id: 2,
    descricao: 'RECEITA',
    enum: 'CR'
  },
]
